import type { SetupFlowDefinition } from "@/types/setup/flow";
import { clubsSetupFlow } from "./flows/clubs";

/**
 * Central registry of setup flows. New persona/segment flows plug in by adding
 * their `SetupFlowDefinition` to the array below — the hub and the generic
 * runner pick them up automatically (mirrors the playbooks/solutions registries).
 */
const setupFlows: SetupFlowDefinition[] = [clubsSetupFlow];

const setupRegistry = new Map<string, SetupFlowDefinition>(
  setupFlows.map((flow) => [flow.meta.slug, flow]),
);

export const getSetupFlow = (slug?: string | null): SetupFlowDefinition | undefined =>
  slug ? setupRegistry.get(slug) : undefined;

export const getAllSetupFlows = (): SetupFlowDefinition[] => Array.from(setupRegistry.values());
